import { Button, ButtonProps } from "@mui/material";
import React from "react";

import { ClassNameMap } from "@mui/styles";

interface OutlinedButtonProps extends ButtonProps {
  fullWidth?: boolean;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  size?: "small" | "large" | "medium";
  disabled?: boolean;
  children: JSX.Element | string;
  noFill?: boolean;
  backgroundColor?: string;
  isSelected?: boolean;
  styles?: (props?: any) => ClassNameMap<"root">;
  onClick?: (e: any) => void;
}

const OutlinedButton = (props: OutlinedButtonProps) => {
  const { children, fullWidth, size, startIcon, endIcon, disabled, styles, onClick, isSelected } =
    props;

  const classes = styles && styles(isSelected);

  return (
    <Button
      variant="outlined"
      disableRipple
      disableElevation
      fullWidth={fullWidth ?? false}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      className={classes && classes.root}
      onClick={(e) => {
        onClick && onClick(e);
      }}
    >
      {children}
    </Button>
  );
};

export default OutlinedButton;
